import type { Dictionary } from "./types";

export const bn: Dictionary = {
  locale: {
    switcherLabel: "বাং",
    fullName: "বাংলা",
  },
  nav: {
    links: {
      home: "হোম",
      projects: "প্রজেক্ট",
      services: "সার্ভিস",
      company: "কোম্পানি",
      blogs: "ব্লগ",
      contactUs: "যোগাযোগ",
      designs: "ডিজাইন",
      about: "আমাদের সম্পর্কে",
      career: "ক্যারিয়ার",
      faqs: "প্রশ্নোত্তর",
    },
    subItems: {
      developments: {
        label: "ডেভেলপমেন্ট",
        desc: "ওয়েবসাইট ও ওয়েব অ্যাপ্লিকেশন",
      },
      designs: {
        label: "ডিজাইন",
        desc: "সোশ্যাল মিডিয়া কনটেন্ট, ব্র্যান্ডিং ও আরও কিছু",
      },
      about: {
        label: "আমাদের সম্পর্কে",
        desc: "আমরা কারা এবং কীভাবে কাজ করি",
      },
      career: {
        label: "ক্যারিয়ার",
        desc: "চলমান নিয়োগ ও আবেদনের প্রক্রিয়া",
      },
      faq: {
        label: "প্রশ্নোত্তর",
        desc: "সাধারণ প্রশ্নের উত্তর",
      },
      contactUs: {
        label: "যোগাযোগ",
        desc: "আমাদের টিমের সঙ্গে যোগাযোগ করুন",
      },
    },
    menu: "মেনু",
    exploreMore: "আরও দেখুন",
    bookMeeting: "মিটিং বুক করুন",
    faqShort: "প্রশ্নোত্তর ?",
    servicesPanel: {
      creative: "ক্রিয়েটিভ",
      development: "ডেভেলপমেন্ট",
    },
  },
  footer: {
    description:
      "Build Web IT একটি সফটওয়্যার ডেভেলপমেন্ট কোম্পানি, যারা ব্যবসায়িক ডিজিটাল সমাধান ও গ্রাফিক ডিজাইন সেবায় বিশেষজ্ঞ। আমাদের লক্ষ্য — অত্যাধুনিক প্রযুক্তি ও দারুণ ইউজার এক্সপেরিয়েন্সের মাধ্যমে ব্যবসাগুলোকে এগিয়ে নেওয়া।",
    contactUs: "যোগাযোগ:",
    explore: "এক্সপ্লোর",
    exploreLinks: {
      home: "হোম",
      projects: "প্রজেক্ট",
      services: "সার্ভিস",
      about: "আমাদের সম্পর্কে",
      careers: "ক্যারিয়ার",
      writeReview: "রিভিউ লিখুন",
    },
    legal: "লিগ্যাল",
    legalLinks: {
      termsAndConditions: "শর্তাবলী",
      privacyPolicy: "প্রাইভেসি পলিসি",
      cookiePolicy: "কুকি পলিসি",
    },
    socials: "সোশ্যাল",
    allRightsReserved: "সর্বস্বত্ব সংরক্ষিত © {year} — Build Web IT",
  },
  legalPage: {
    contents: "সূচিপত্র",
    effectiveDate: "কার্যকর তারিখ:",
    tocAriaLabel: "সূচিপত্র",
    email: "ইমেইল:",
    phone: "ফোন:",
  },
  home: {
    banner: {
      titleTop: "আধুনিক ব্যবসার জন্য স্মার্ট সমাধান",
      title1: "আমরা ডিজিটাল সলিউশন তৈরি করি,",
      title2: "যাতে আপনার ব্যবসা অনলাইনে এগিয়ে যায়",
      description:
        "Build Web IT-তে আমরা এমন ওয়েবসাইট তৈরি করি যা কনভার্ট করে, এমন ইউজার এক্সপেরিয়েন্স ডিজাইন করি যা সহজবোধ্য, এবং এমন অনলাইন সমাধান বানাই যা আপনার ব্যবসার জন্য গ্রাহকের কাছে পৌঁছানো ও বৃদ্ধি পাওয়াকে সহজ করে।",
      reachOut: "যোগাযোগ করুন",
    },
    services: {
      title: "দেখে নিন আমরা আপনার জন্য কী বানাতে পারি",
      description:
        "আপনার ব্যবসা ডিজাইন, ডেভেলপ ও বাড়িয়ে তোলার জন্য আমাদের প্রধান সেবাগুলো।",
      weProvide: "আমরা যা দিচ্ছি:",
      learnMore: "বিস্তারিত দেখুন",
    },
    projects: {
      title: "আমাদের গর্বের কাজ",
      description: "আমাদের সেরা ডেভেলপমেন্ট কাজের একটি ঝলক।",
      viewDetails: "বিস্তারিত দেখুন",
      live: "লাইভ",
      seeAllProjects: "সব প্রজেক্ট দেখুন",
    },
    designs: {
      title: "ভালোবাসা দিয়ে গড়া ডিজাইন",
      description:
        "আমাদের ক্রিয়েটিভ কাজগুলো দেখুন, যেখানে কল্পনা ও কৌশল মিলে ব্র্যান্ডকে আলাদাভাবে তুলে ধরে।",
      viewAll: "সব ডিজাইন দেখুন",
    },
    skills: {
      eyebrow: "আমাদের টেক স্ট্যাক",
      title: "টুলস ও টেকনোলজিতে আমাদের দক্ষতা",
      description:
        "Build Web IT-তে আমরা সেরা টুলস ও টেকনোলজিকে অভিজ্ঞতার সঙ্গে মিলিয়ে এমন ডিজিটাল সমাধান তৈরি করি যা আপনার ব্যবসাকে সফল হতে সাহায্য করে। চমৎকার ডিজাইন, দ্রুতগতির ওয়েবসাইট কিংবা শক্তিশালী অ্যাপ — আমাদের টিম প্রতিটি প্রজেক্টকে কার্যকর, নির্ভরযোগ্য ও আপনার লক্ষ্য অনুযায়ী তৈরি করে।",
      categories: {
        frontend: "ফ্রন্টএন্ড",
        backend: "ব্যাকএন্ড",
        data: "ডাটা ও ক্লাউড",
        design: "ডিজাইন",
      },
    },
    team: {
      title: "আমাদের কো-ফাউন্ডারদের সঙ্গে পরিচিত হোন",
      description: "",
      designations: {
        "software-developer": "সফটওয়্যার ডেভেলপার",
        "graphics-designer": "গ্রাফিক্স ডিজাইনার",
      },
    },
    workflow: {
      title: "দেখুন আমরা কীভাবে কাজ করি",
      description:
        "আপনার ব্যবসার লক্ষ্য অনুযায়ী ওয়েবসাইট বানাতে আমরা ৫টি সহজ ধাপ অনুসরণ করি। পরিকল্পনা থেকে লঞ্চ পর্যন্ত পুরো প্রক্রিয়াটিকে আমরা মসৃণ ও নির্ভরযোগ্য রাখি।",
      stepLabel: "ধাপ",
      steps: {
        consultation: {
          title: "পরামর্শ",
          description:
            "আমরা আপনার সঙ্গে কথা বলে আপনার ব্যবসা, লক্ষ্য এবং সলিউশন বা ওয়েবসাইট থেকে আপনি ঠিক কী চান — তা বুঝে নিই।",
        },
        planningDesign: {
          title: "পরিকল্পনা ও ডিজাইন",
          description:
            "আমরা একটি সহজ পরিকল্পনা তৈরি করি, লেআউট ডিজাইন করি এবং দেখাই আপনার সিস্টেম বা ওয়েবসাইট দেখতে ও কাজ করতে কেমন হবে।",
        },
        development: {
          title: "ডেভেলপমেন্ট",
          description:
            "সর্বশেষ টুলস ও SEO বেস্ট-প্র্যাকটিস ব্যবহার করে আমরা আপনার সলিউশন বা ওয়েবসাইট তৈরি করি।",
        },
        testing: {
          title: "টেস্টিং",
          description:
            "সব ডিভাইসে যেন সলিউশন বা ওয়েবসাইট মসৃণভাবে কাজ করে — তা নিশ্চিত করতে আমরা সবকিছু সতর্কভাবে যাচাই করি।",
        },
        launchSupport: {
          title: "লঞ্চ ও সাপোর্ট",
          description:
            "আমরা আপনার সলিউশন বা ওয়েবসাইট লঞ্চ করি এবং চলমান সাপোর্ট দিয়ে সবকিছু আপডেট ও সচল রাখি।",
        },
      },
    },
    bookAMeeting: {
      cardTitle: "আপনার পরবর্তী বড় আইডিয়া নিয়ে কথা বলার সময়?",
      cardDescription:
        "আপনি কী নিয়ে কাজ করছেন — বা স্বপ্ন দেখছেন — তা আমরা শুনতে চাই। আপনার সুবিধামতো ৩০ মিনিটের একটি সময় বেছে নিন, আর কথা বলুন কীভাবে আমরা আপনার ভিশনকে ডিজাইন, ডেভেলপ ও বাস্তবে রূপ দিতে পারি। আপনার প্রজেক্ট আজই শুরু হতে পারে।",
      sectionTitle: "আমাদের প্রক্রিয়া সহজ, মসৃণ ও কার্যকর।",
      steps: {
        initiateStrategy: {
          title: "একটি স্ট্র্যাটেজি সেশন শুরু করুন",
          description:
            "আমাদের সঙ্গে একটি পরামর্শমূলক মিটিংয়ে যুক্ত হয়ে আপনার ব্যবসার লক্ষ্যগুলো খুঁজে বের করুন। আমরা একটি উপযোগী পরিকল্পনা সাজাবো, মূল লক্ষ্য নির্ধারণ করবো, সময়সীমা ঠিক করবো এবং প্রয়োজনীয় রিসোর্স চিহ্নিত করবো।",
        },
        shapeTeam: {
          title: "আপনার স্বপ্নের টিম গড়ুন",
          description:
            "দ্রুত আপনার প্রজেক্টের রূপরেখা চূড়ান্ত করুন, কোলাবোরেশন মডেল বেছে নিন এবং আমাদের বাছাই-করা এক্সপার্টদের আপনার ভিশনের সঙ্গে নির্বিঘ্নে যুক্ত করুন।",
        },
        beginJourney: {
          title: "আশাবাদ নিয়ে যাত্রা শুরু করুন",
          description:
            "গুরুত্বপূর্ণ লক্ষ্যগুলোর ব্যাপারে একমত হয়ে নিন, আমরা কাজ এগিয়ে নেবো। আপনার পরিবর্তনশীল চাহিদার সঙ্গে আমাদের অগ্রগতি মিলিয়ে নিয়মিত আপডেট দেওয়া হবে। আপনার সন্তুষ্টিই আমাদের আরও ভালো করার অনুপ্রেরণা।",
        },
      },
    },
    contact: {
      title: "চলুন একসাথে গড়ি",
      description:
        "কোনো প্রজেক্টের পরিকল্পনা আছে? আপনার ব্যবসা বাড়াতে সাহায্য করবে এমন ওয়েবসাইট বা ডিজাইন বানাতে আমরা প্রস্তুত। আপনি কী চান বলুন — বাকিটা আমরা সামলাবো।",
      contactTitle: "ফোনে কথা বলতে চান?",
      emailTitle: "আমাদের লিখুন",
      letsGetStarted: "চলুন শুরু করি",
      submit: "সাবমিট",
      sending: "পাঠানো হচ্ছে…",
      successDefault: "যোগাযোগের ফর্ম সফলভাবে জমা হয়েছে!",
      errorDefault: "ফর্ম জমা দিতে সমস্যা হয়েছে।",
      requiredError: "{field} আবশ্যক।",
      genericError: "কিছু একটা ভুল হয়েছে। আবার চেষ্টা করুন।",
      fields: {
        name: { label: "আপনার নাম", placeholder: "এখানে আপনার নাম লিখুন" },
        email: {
          label: "আপনার ইমেইল",
          placeholder: "এখানে আপনার ইমেইল লিখুন",
        },
        phone: {
          label: "আপনার ফোন (WhatsApp হলে আরও ভালো)",
          placeholder: "এখানে আপনার ফোন নম্বর লিখুন",
        },
        message: { label: "মেসেজ", placeholder: "এখানে আপনার বার্তা লিখুন" },
      },
    },
    faq: {
      title: "প্রচলিত প্রশ্নোত্তর",
      description: "আমাদের সেবা নিয়ে সবচেয়ে সাধারণ প্রশ্নগুলোর উত্তর দেখুন।",
      viewAll: "সব প্রশ্নোত্তর দেখুন",
    },
  },
  metadata: {
    keywords:
      "ওয়েব ডেভেলপমেন্ট, গ্রাফিক ডিজাইন, SEO ওয়েবসাইট, রেসপনসিভ ওয়েবসাইট, ফ্রন্টএন্ড ডেভেলপার, ব্র্যান্ডিং, ক্রিয়েটিভ ডিজাইন, ডিজিটাল সলিউশন, Build Web IT",
    ogLocale: "bn_BD",
    pages: {
      home: {
        title: "Build Web IT",
        description:
          "Build Web IT দক্ষ ওয়েব ডেভেলপমেন্ট, গ্রাফিক ডিজাইন, SEO-ফ্রেন্ডলি ও রেসপনসিভ ওয়েবসাইট এবং কাস্টম ডিজিটাল সলিউশন দেয়।",
        ogTitle:
          "প্রফেশনাল ওয়েব ডেভেলপমেন্ট ও ক্রিয়েটিভ ডিজাইন | Build Web IT",
        ogDescription:
          "Build Web IT লোকাল ও গ্লোবাল ক্লায়েন্টদের জন্য রেসপনসিভ, SEO-ফ্রেন্ডলি ওয়েবসাইট ও ব্র্যান্ডিং তৈরি করে।",
      },
      aboutUs: {
        title: "আমাদের সম্পর্কে",
        description:
          "Build Web IT-এর লক্ষ্য, ভিশন এবং কাস্টম ওয়েব ডেভেলপমেন্ট, ডিজাইন ও ডিজিটাল সলিউশন তৈরি করা আমাদের নিবেদিত টিম সম্পর্কে জানুন।",
        ogTitle: "Build Web IT সম্পর্কে | আমাদের লক্ষ্য ও টিম",
        ogDescription:
          "Build Web IT-এর লক্ষ্য, ভিশন এবং রেসপনসিভ ওয়েবসাইট, ব্র্যান্ডিং ও ডিজিটাল সলিউশন তৈরি করা আমাদের প্রতিভাবান টিমকে জানুন।",
      },
      services: {
        title: "সার্ভিস",
        description:
          "Build Web IT-এর ওয়েব ডেভেলপমেন্ট, প্রোডাক্ট ডিজাইন, UI/UX ডিজাইন ও অ্যাপ ডিজাইন সেবা দেখুন। আমরা রেসপনসিভ, SEO-ফ্রেন্ডলি ও ইউজার-ফ্রেন্ডলি ডিজিটাল সলিউশন তৈরি করি।",
        ogTitle: "আমাদের সার্ভিস | Build Web IT",
        ogDescription:
          "লোকাল ও গ্লোবাল ক্লায়েন্টদের জন্য Build Web IT-এর ওয়েব ডেভেলপমেন্ট, UI/UX, প্রোডাক্ট ও অ্যাপ ডিজাইন সেবা।",
      },
      projects: {
        title: "প্রজেক্ট",
        description:
          "ই-কমার্স, ব্যবসায়িক এবং সার্ভিস-ভিত্তিক ওয়েবসাইট নিয়ে Build Web IT-এর পোর্টফোলিও দেখুন — আধুনিক, রেসপনসিভ ও SEO-ফ্রেন্ডলি ডিজাইনে তৈরি।",
        ogTitle: "আমাদের প্রজেক্ট | Build Web IT",
        ogDescription:
          "Build Web IT-এর কাজ দেখুন — দ্রুত, অ্যাক্সেসিবল এবং কনভার্সন-ফোকাসড ই-কমার্স, ব্যবসায়িক ও পোর্টফোলিও ওয়েবসাইট।",
      },
      projectsDetail: {
        title: "প্রজেক্ট",
        description: "আমাদের প্রজেক্ট কেস স্টাডি বিস্তারিতভাবে দেখুন।",
      },
      designs: {
        title: "ডিজাইন",
        description:
          "Build Web IT-এর ক্রিয়েটিভ গ্রাফিক ডিজাইন পোর্টফোলিও দেখুন — ব্র্যান্ড আইডেন্টিটি, প্যাকেজিং, এডিটোরিয়াল এবং সোশ্যাল মিডিয়া ভিজ্যুয়াল।",
        ogTitle: "আমাদের ডিজাইন | Build Web IT",
        ogDescription:
          "Build Web IT-এর ক্রিয়েটিভ গ্রাফিক ডিজাইন কাজ — ব্র্যান্ড আইডেন্টিটি, প্যাকেজিং, এডিটোরিয়াল এবং সোশ্যাল-ফার্স্ট ভিজ্যুয়াল।",
      },
      contactUs: {
        title: "যোগাযোগ",
        description:
          "Build Web IT-এর সঙ্গে যোগাযোগ করুন। আপনার প্রজেক্টের কথা আমরা শুনতে চাই — লিখে পাঠান, আমরা দ্রুতই উত্তর দেবো।",
        ogTitle: "Build Web IT-এর সঙ্গে যোগাযোগ",
        ogDescription:
          "আপনার ওয়েব ডেভেলপমেন্ট, ডিজাইন বা ডিজিটাল সলিউশন প্রজেক্ট নিয়ে আমাদের লিখুন — আমরা দ্রুত উত্তর দেবো।",
      },
      careers: {
        title: "ক্যারিয়ার",
        description:
          "Build Web IT-এ ক্যারিয়ারের সুযোগ দেখুন। রেসপনসিভ, SEO-ফ্রেন্ডলি ও ইউজার-ফোকাসড ডিজিটাল প্রোডাক্ট তৈরি করা টিমে যোগ দিন।",
        ogTitle: "Build Web IT-এ ক্যারিয়ার",
        ogDescription:
          "Build Web IT-এ চলমান নিয়োগ ও আবেদনের প্রক্রিয়া — অসাধারণ ওয়েব ও ডিজাইন এক্সপেরিয়েন্স তৈরিতে আমাদের সঙ্গে যোগ দিন।",
      },
      careersDetail: {
        title: "ক্যারিয়ার",
        description: "ই-কমার্স ও সার্ভিস-ভিত্তিক ওয়েবসাইটের পোর্টফোলিও দেখুন।",
      },
      testimonials: {
        title: "প্রশংসাপত্র",
        description:
          "Build Web IT-এর ওয়েব ডেভেলপমেন্ট, ডিজাইন ও ডিজিটাল সলিউশন নিয়ে ক্লায়েন্টরা কী বলেন — পড়ুন।",
        ogTitle: "প্রশংসাপত্র | Build Web IT",
        ogDescription:
          "Build Web IT-এর ওয়েব ডেভেলপমেন্ট ও ডিজাইন কাজ নিয়ে বাস্তব ক্লায়েন্ট ফিডব্যাক।",
      },
      writeReview: {
        title: "রিভিউ দিন",
        description:
          "Build Web IT-এর সঙ্গে আপনার অভিজ্ঞতা শেয়ার করুন — আপনার রিভিউ অন্যদের একটি নির্ভরযোগ্য ওয়েব ও ডিজাইন পার্টনার খুঁজে পেতে সাহায্য করবে।",
        ogTitle: "রিভিউ দিন | Build Web IT",
        ogDescription:
          "আমরা কেমন কাজ করেছি — জানান। আপনার রিভিউ ভবিষ্যৎ ক্লায়েন্টদের সাহায্য করবে।",
      },
      faq: {
        title: "প্রশ্নোত্তর",
        description:
          "Build Web IT-এর সেবা, প্রাইসিং, টাইমলাইন, প্রক্রিয়া, মেইনটেন্যান্স ও সাপোর্ট নিয়ে সাধারণ প্রশ্নের স্পষ্ট উত্তর পান।",
        ogTitle: "প্রশ্নোত্তর | Build Web IT",
        ogDescription:
          "Build Web IT-এর সঙ্গে কাজ সম্পর্কে যা যা জানা দরকার — সেবা, প্রজেক্ট স্কোপ, খরচ, টাইমলাইন ও চলমান সাপোর্ট।",
      },
      blogs: {
        title: "ব্লগ",
        description:
          "ওয়েব ডেভেলপমেন্ট, ডিজাইন, SEO এবং ভালো ডিজিটাল প্রোডাক্ট তৈরির পরামর্শ পেতে Build Web IT-এর ব্লগ পড়ুন।",
        ogTitle: "Build Web IT ব্লগ",
        ogDescription:
          "Build Web IT-এর কাছ থেকে ওয়েব ডেভেলপমেন্ট, ডিজাইন ও ডিজিটাল প্রোডাক্ট গ্রোথ নিয়ে ইনসাইট, টিউটোরিয়াল ও গল্প।",
      },
      bookAMeeting: {
        title: "মিটিং বুক করুন",
        description:
          "আপনার প্রজেক্টের লক্ষ্য, সময়সীমা এবং কীভাবে আমরা সাহায্য করতে পারি — তা নিয়ে Build Web IT-এর সঙ্গে ৩০ মিনিটের একটি মিটিং বুক করুন।",
        ogTitle: "মিটিং বুক করুন | Build Web IT",
        ogDescription:
          "আপনার সুবিধামতো একটি সময় বেছে নিন — আপনার প্রজেক্ট নিয়ে কথা বলি। Build Web IT।",
      },
      termsAndConditions: {
        title: "শর্তাবলী",
        description:
          "Build Web IT-এর ওয়েবসাইট ও সেবা ব্যবহারের শর্তাবলী পড়ুন — স্কোপ, পেমেন্ট, রিভিশন, মেধাস্বত্ব এবং আরও অনেক কিছু।",
        ogTitle: "শর্তাবলী | Build Web IT",
        ogDescription:
          "Build Web IT-এর ওয়েবসাইট এবং আমাদের ওয়েব, অ্যাপ ও ডিজাইন সেবা ব্যবহারের শর্তাবলী।",
      },
      privacyPolicy: {
        title: "গোপনীয়তা নীতি",
        description:
          "Build Web IT কীভাবে আপনার ব্যক্তিগত তথ্য সংগ্রহ, ব্যবহার, শেয়ার ও সুরক্ষা করে এবং আপনার তথ্যের উপর আপনার অধিকার সম্পর্কে জানুন।",
        ogTitle: "গোপনীয়তা নীতি | Build Web IT",
        ogDescription:
          "Build Web IT কীভাবে আপনার তথ্য পরিচালনা করে — কী সংগ্রহ করি, কেন, কীভাবে সুরক্ষা দিই এবং আপনার গোপনীয়তার অধিকার।",
      },
      cookiePolicy: {
        title: "কুকি পলিসি",
        description:
          "Build Web IT কীভাবে কুকি ও অনুরূপ প্রযুক্তি ব্যবহার করে, আমরা কোন ধরনের কুকি ব্যবহার করি এবং আপনি কীভাবে তা নিয়ন্ত্রণ করবেন তা জানুন।",
        ogTitle: "কুকি পলিসি | Build Web IT",
        ogDescription:
          "Build Web IT কীভাবে কুকি ব্যবহার করে, কেন ব্যবহার করি এবং আপনি কীভাবে ব্রাউজারে তা নিয়ন্ত্রণ করতে পারেন।",
      },
    },
  },
  // NOTE: every `blurb` below is intentionally exactly 12 words AND
  // contains NO hyphenated compound words — kept in sync with the
  // same invariant in `en.ts` so the home service cards line up
  // visually across both locales.
  homeServiceCards: {
    ecommerce: {
      title: "ই-কমার্স",
      blurb:
        "ঝামেলাহীন চেকআউট, সহজ ক্যাটালগ ও পরিষ্কার CMS দিয়ে তৈরি স্টোরফ্রন্ট, সহজে পরিচালনাযোগ্য।",
      shortBlurb:
        "স্টোরফ্রন্ট যা কনভার্ট করে — দ্রুত, স্কেলেবল ও সহজে ম্যানেজযোগ্য।",
      items: [
        "প্রোডাক্ট ক্যাটালগ",
        "সার্চ ফিল্টার",
        "স্মুথ চেকআউট",
        "সিকিওর পেমেন্ট",
        "অর্ডার ট্র্যাকিং",
        "সেলস অ্যানালিটিক্স",
      ],
    },
    landing: {
      title: "ল্যান্ডিং পেজ",
      blurb:
        "মডুলার সেকশনসহ তীক্ষ্ণ ক্যাম্পেইন ও লঞ্চ পেজ, দ্রুত শিপ করার জন্য তৈরি।",
      shortBlurb:
        "ল্যান্ডিং পেজ যা দ্রুত লোড হয় ও কনভার্ট করে।",
      items: [
        "ব্র্যান্ড ন্যারেটিভ",
        "হিরো সেকশন",
        "মডুলার লেআউট",
        "কনভার্সন হুকস",
        "লিড ফর্ম",
        "SEO স্কিমা",
      ],
    },
    custom: {
      title: "কাস্টম ওয়েবসাইট",
      blurb:
        "আপনার লক্ষ্য অনুযায়ী দ্রুত লোডিং, অ্যাক্সেসিবল ও সহজে ম্যানেজযোগ্য আধুনিক ওয়েবসাইট তৈরি।",
      shortBlurb:
        "আপনার উপযোগী দ্রুত, অ্যাক্সেসিবল ওয়েবসাইট — সহজে ম্যানেজযোগ্য।",
      items: [
        "বিজনেস সাইট",
        "পোর্টফোলিও পেজ",
        "ব্লগ প্ল্যাটফর্ম",
        "সার্ভিস লিস্টিং",
        "রেস্টুরেন্ট মেনু",
        "রিয়েল এস্টেট",
      ],
    },
    mobileApp: {
      title: "মোবাইল অ্যাপ",
      blurb:
        "iOS ও Android এর জন্য ক্রসপ্ল্যাটফর্ম অ্যাপ, স্মুথ ইউএক্স ও পরিচ্ছন্ন আর্কিটেকচারে।",
      shortBlurb: "দ্রুত, নির্ভরযোগ্য iOS ও Android অ্যাপ — স্কেলের জন্য তৈরি।",
      items: [
        "iOS ডেভেলপমেন্ট",
        "Android ডেভেলপমেন্ট",
        "React Native",
        "পুশ নোটিফিকেশন",
        "অফলাইন সাপোর্ট",
        "অ্যাপ স্টোর",
      ],
    },
    uiux: {
      title: "UI/UX ডিজাইন",
      blurb:
        "ব্যবহারকারী কেন্দ্রিক ইন্টারফেস, যাচাই করা ইউজার ফ্লো ও অ্যাক্সেসিবল প্যাটার্ন দিয়ে তৈরি।",
      shortBlurb:
        "রিসার্চ ও ডিজাইন সিস্টেম দ্বারা সমর্থিত ইউজার-ফ্রেন্ডলি ইন্টারফেস।",
      items: [
        "ইউজার রিসার্চ",
        "ওয়্যারফ্রেম ডিজাইন",
        "ডিজাইন সিস্টেম",
        "ইন্টারঅ্যাকটিভ প্রোটোটাইপ",
        "ইউজেবিলিটি টেস্টিং",
        "WCAG কমপ্লায়েন্স",
      ],
    },
  },
  navServiceCategoryItems: {
    creative: {
      webDesign: {
        name: "ওয়েব ডিজাইন",
        shortDescription: "সুন্দর ও কার্যকর ওয়েবসাইট তৈরি",
      },
      brandIdentity: {
        name: "ব্র্যান্ড আইডেন্টিটি",
        shortDescription: "লোগো, কালার সিস্টেম ও ব্র্যান্ড গাইডলাইন",
      },
      graphicDesign: {
        name: "গ্রাফিক ডিজাইন",
        shortDescription: "ওয়েব ও প্রিন্টের জন্য মার্কেটিং ভিজ্যুয়াল",
      },
    },
    development: {
      webDevelopment: {
        name: "ওয়েব ডেভেলপমেন্ট",
        shortDescription: "রেসপনসিভ ও কার্যকর ওয়েবসাইট তৈরি",
      },
      mobileAppDevelopment: {
        name: "মোবাইল অ্যাপ ডেভেলপমেন্ট",
        shortDescription: "iOS ও Android-এর জন্য নেটিভ ও ক্রস-প্ল্যাটফর্ম অ্যাপ",
      },
      ecommerceSolutions: {
        name: "ই-কমার্স সলিউশন",
        shortDescription: "অনলাইন স্টোর ও শপিং অভিজ্ঞতা তৈরি",
      },
    },
  },
  projectDetail: {
    fallbackTitle: "প্রজেক্ট বিবরণ",
    liveDemo: "লাইভ ডেমো",
    mockupImageAlt: "মকআপ ইমেজ",
    largeImageAlt: "বড় ইমেজ",
    landingImageAlt: "ল্যান্ডিং",
  },
  projectsList: {
    headerTitle: "নিজেই দেখুন আমাদের কাজের ফল — কথা নয়, কাজই বলবে সব",
    headerDescription:
      "শুরু থেকে শেষ পর্যন্ত সবকিছু আমরা সামলাই, যাতে আপনার কাজ সহজ হয়। আমাদের নিবেদিত টিম শুধু প্রতিশ্রুতি নয় — বাস্তব ফলাফল ডেলিভারি করে।",
    filterAll: "সব",
    categories: {
      ecommerce: "ই-কমার্স",
      development: "কাস্টম ডেভেলপমেন্ট",
      creative: "সোশ্যাল মিডিয়া কনটেন্ট",
      webdesign: "ওয়েব ডিজাইন",
      portfolio: "পোর্টফোলিও",
    },
  },
  blogsList: {
    filterAll: "সব",
    readMore: "আরও পড়ুন",
    sidebar: {
      categoriesHeader: "ক্যাটাগরি",
      categories: {
        productivity: "প্রোডাক্টিভিটি",
        development: "ডেভেলপমেন্ট",
        uiUx: "UI/UX",
        tutorials: "টিউটোরিয়াল",
      },
    },
    mediumLogoAlt: "Medium লোগো",
    linkedinLogoAlt: "LinkedIn লোগো",
    blogImageAlt: "ব্লগ ইমেজ",
  },
  notFound: {
    title: "পেজ খুঁজে পাওয়া যায়নি",
    description:
      "দুঃখিত, আপনি যে পেজটি খুঁজছেন সেটি নেই বা সরিয়ে নেওয়া হয়েছে।",
    goHome: "হোমে ফিরে যান",
  },
  bookMeeting: {
    calendarLabel: "ক্যালেন্ডার",
    timezoneLabel: "টাইম জোন",
    timezoneSelected: "নির্বাচিত:",
    timezonePlaceholder: "আপনার টাইম জোন বেছে নিন",
    timezoneChanged: "টাইম জোন পরিবর্তিত হয়েছে। দয়া করে আবার তারিখ ও সময় বেছে নিন।",
    previousMonth: "আগের মাস",
    nextMonth: "পরের মাস",
    availableTimes: "ফাঁকা সময়",
    each: "প্রতিটি",
    pickDateHint: "ফাঁকা স্লট দেখতে একটি তারিখ বেছে নিন।",
    noFutureSlots: "{timezone}-এ আজকের জন্য আর কোনো সময় বাকি নেই।",
    enterYourDetails: "আপনার তথ্য লিখুন",
    yourSelection: "আপনার নির্বাচন",
    chooseDateTimeFirst: "প্রথমে তারিখ ও সময় বেছে নিন",
    youSelected: "আপনি বেছে নিয়েছেন",
    changeTime: "← সময় পরিবর্তন করুন",
    bookButton: "মিটিং বুক করুন",
    booking: "বুক করা হচ্ছে…",
    reset: "রিসেট",
    meetingConfirmed: "মিটিং নিশ্চিত হয়েছে!",
    confirmedMessage: "আমরা ২৪ ঘণ্টার মধ্যে আপনার সঙ্গে যোগাযোগ করব।",
    bookAnother: "আরেকটি বুক করুন",
    selected: "নির্বাচিত",
    select: "বেছে নিন",
    confirm: "নিশ্চিত করুন",
    continueLabel: "এগিয়ে যান",
    requiredSuffix: "*",
    fields: {
      name: { label: "আপনার নাম *", placeholder: "এখানে আপনার নাম লিখুন" },
      phone: {
        label: "আপনার ফোন (WhatsApp হলে আরও ভালো) *",
        placeholder: "এখানে আপনার ফোন নম্বর লিখুন",
      },
      email: {
        label: "আপনার ইমেইল *",
        placeholder: "এখানে আপনার ইমেইল লিখুন",
      },
      message: {
        label: "সংক্ষেপে বলুন কী নিয়ে কথা বলতে চান *",
        placeholder: "কী নিয়ে আলোচনা করতে চান?",
      },
    },
    weekdays: {
      mon: "সোম",
      tue: "মঙ্গল",
      wed: "বুধ",
      thu: "বৃহঃ",
      fri: "শুক্র",
      sat: "শনি",
      sun: "রবি",
    },
  },
  pagination: {
    label: "পেজিনেশন",
    previous: "আগের পেজ",
    next: "পরের পেজ",
  },
  careerDetail: {
    backToList: "← জব তালিকায় ফিরে যান",
    context: "জবের বিবরণ:",
    requirements: "জবের চাহিদা:",
    additionalRequirements: "অতিরিক্ত চাহিদা:",
    educationalRequirements: "শিক্ষাগত যোগ্যতা:",
    benefits: "সুবিধাসমূহ:",
    applicationDeadline: "আবেদনের শেষ তারিখ:",
    skills: "দক্ষতা",
    jobLocation: "চাকরির অবস্থান:",
    emailYourCv: "আপনার CV / রিজিউমে পাঠান:",
    deadlinePassed:
      "এই পদের জন্য আবেদনের সময়সীমা শেষ হয়ে যাওয়ায় আমরা আর নতুন আবেদন গ্রহণ করছি না!",
  },
  designsPage: {
    title: "ভালোবাসা দিয়ে গড়া ডিজাইন",
    description:
      "আমাদের ক্রিয়েটিভ কাজগুলো দেখুন, যেখানে কল্পনা ও কৌশল মিলে ব্র্যান্ডকে আলাদাভাবে তুলে ধরে।",
  },
  blogsPage: {
    title: "ওয়েব ডিজাইন ও ডেভেলপমেন্টের নতুন সবকিছু আবিষ্কার করুন",
    description:
      "টিউটোরিয়াল থেকে ইন্ডাস্ট্রি ইনসাইট — এগিয়ে থাকার জন্য যা যা দরকার, সবই আছে আমাদের ব্লগে। আপডেট পেতে সাবস্ক্রাইব করুন, কিছুই মিস করবেন না!",
  },
  writeReviewPage: {
    pageTitle: "আপনার অভিজ্ঞতা শেয়ার করুন",
    pageDescription:
      "অন্যদের জানান আপনার অভিজ্ঞতা। আপনার কথাগুলো ভবিষ্যৎ ক্লায়েন্টদের সাহায্য করবে।",
    formTitle: "একটি প্রশংসাপত্র দিন",
    fields: {
      name: {
        label: "আপনার নাম",
        placeholder: "যেমন: রাফসান হোসেন",
        required: "আপনার নাম আবশ্যক।",
      },
      designation: {
        label: "আপনার পদবী (ঐচ্ছিক)",
        placeholder: "CTO, Product Manager…",
      },
      company: {
        label: "কোম্পানি (ঐচ্ছিক)",
        placeholder: "Acme Inc.",
      },
      content: {
        label: "আপনার অভিজ্ঞতা শেয়ার করুন",
        placeholder: "আমাদের সঙ্গে কাজের অভিজ্ঞতা লিখুন…",
        required: "অনুগ্রহ করে আপনার অভিজ্ঞতা লিখুন।",
      },
      rating: {
        legend: "আপনার রেটিং",
        rangeError: "রেটিং ১ থেকে ৫-এর মধ্যে হতে হবে।",
      },
    },
    submit: "সাবমিট করুন",
    submitting: "জমা দেওয়া হচ্ছে...",
    successTitle: "জমা হয়েছে!",
    successMessage: "আপনার রিভিউয়ের জন্য ধন্যবাদ",
    successCta: "চমৎকার",
    errorTitle: "জমা দিতে ব্যর্থ",
    errorMessage: "রিভিউ জমা দিতে সমস্যা হয়েছে।",
    errorCta: "বন্ধ করুন",
  },
  careersPage: {
    banner: {
      title: "ক্যারিয়ার",
      description:
        "প্রযুক্তি ব্যবহার করে প্রতিদিন ব্যবসা ও ভোক্তা অভিজ্ঞতায় বাস্তব ও বিশ্বাসযোগ্য প্রভাব তৈরির আগ্রহ আছে।",
    },
    whyJoinUs: {
      title: "আমাদের সঙ্গে কেন কাজ করবেন",
      joinUsCta: "যোগ দিন",
      points: {
        fastGrowing: {
          title: "দ্রুত বর্ধনশীল কোম্পানি",
          description:
            "এমন একটি গতিশীল টিমে যোগ দিন যা নতুন প্রজেক্টের সঙ্গে দ্রুত বাড়ছে।",
        },
        greatColleagues: {
          title: "চমৎকার সহকর্মী ও সাপোর্ট",
          description:
            "এমন একটি সহযোগিতামূলক টিমের সঙ্গে কাজ করুন যা সহযোগিতা ও বৃদ্ধিকে গুরুত্ব দেয়।",
        },
        keepLearning: {
          title: "শেখা থামাবেন না",
          description: "আপনার দক্ষতা বাড়াতে চলমান শেখার সুযোগ গ্রহণ করুন।",
        },
        latestStack: {
          title: "সর্বশেষ টেকনোলজি স্ট্যাক",
          description: "প্রতিদিনের কাজে আধুনিক টুলস ও টেকনোলজি ব্যবহার করুন।",
        },
        takeCharge: {
          title: "দায়িত্ব নিন",
          description:
            "উদ্যোগের নেতৃত্ব দিন এবং আপনার প্রজেক্টের মালিকানা নিন।",
        },
        crossDomain: {
          title: "ক্রস-ডোমেইন অভিজ্ঞতা",
          description:
            "বিভিন্ন ক্ষেত্রে কাজের অভিজ্ঞতা অর্জন করে আপনার দক্ষতার পরিধি বাড়ান।",
        },
      },
    },
    jobPost: {
      sectionTitle: "চলমান নিয়োগ",
      applyNow: "এখনই আবেদন করুন",
      deadlineLabel: "শেষ তারিখ:",
      noJobs: "কোনো জব পোস্ট নেই",
      noJobsHint: "এই মুহূর্তে কোনো খালি পদ নেই। পরে আবার দেখুন।",
    },
  },
  servicesPage: {
    hero: {
      titleLine1: "প্রফেশনাল",
      titleLine2: "ওয়েব সার্ভিস",
      description:
        "আমাদের পূর্ণাঙ্গ ওয়েব ডেভেলপমেন্ট ও ডিজাইন সার্ভিসের মাধ্যমে আপনার ডিজিটাল উপস্থিতিকে রূপান্তরিত করুন।",
      exploreCta: "আমাদের সার্ভিস দেখুন",
    },
    letsTalk: "চলুন কথা বলি",
    cta: {
      title: "শুরু করতে প্রস্তুত?",
      description:
        "আপনার প্রজেক্ট নিয়ে আলোচনা করি এবং একসাথে চমৎকার কিছু তৈরি করি। আপনার ভিশনকে বাস্তবে রূপ দিতে আমাদের টিম প্রস্তুত।",
      button: "আপনার প্রজেক্ট শুরু করুন",
    },
    services: {
      ecommerce: {
        title: "ই-কমার্স",
        bannerDescription:
          "আমরা এমন ই-কমার্স ওয়েবসাইট তৈরি করি — যা সিকিউর, দ্রুতগতির এবং অনলাইনে পণ্য বিক্রির জন্য সহজে ম্যানেজযোগ্য।",
        description:
          "আমরা এমন ই-কমার্স ওয়েবসাইট বানাই যা অনলাইনে পণ্য বিক্রিতে সাহায্য করে — সহজ ম্যানেজমেন্ট ও মসৃণ ইউজার এক্সপেরিয়েন্সসহ।",
        subServices: [
          "কাস্টম শপিং কার্ট ও চেকআউট",
          "নিরাপদ পেমেন্ট ইন্টিগ্রেশন",
          "অর্ডার ও শিপিং ম্যানেজমেন্ট",
          "অ্যানালিটিক্স, সেলস রিপোর্টিং ও কাস্টম রিকোয়ারমেন্ট",
        ],
      },
      landing: {
        title: "ল্যান্ডিং পেজ",
        bannerDescription:
          "ক্যাম্পেইন ও প্রোডাক্ট লঞ্চের জন্য পরিষ্কার মেসেজিং, মডিউলার সেকশন এবং পারফরম্যান্স বাজেট সহ ল্যান্ডিং পেজ — দ্রুত লঞ্চ ও দ্রুত ইটারেট করার জন্য তৈরি।",
        description:
          "আমরা এমন ল্যান্ডিং পেজ তৈরি করি যা দ্রুত লোড হয়, প্রফেশনাল দেখায় এবং আপনার কনভার্সন বাড়াতে সাহায্য করে।",
        subServices: [
          "অতি দ্রুত পারফরম্যান্স",
          "SEO-অপ্টিমাইজড আর্কিটেকচার",
          "Figma থেকে কোডে পিক্সেল-পারফেক্ট রূপান্তর",
          "ইউজার-ফ্রেন্ডলি ইন্টারফেস",
        ],
      },
      mobileApp: {
        title: "মোবাইল অ্যাপ",
        bannerDescription:
          "আমরা iOS ও Android-এর জন্য এমন মোবাইল অ্যাপ বানাই — যা দ্রুত, নির্ভরযোগ্য এবং আপনার গ্রাহকদের ব্যবহারের জন্য সহজ।",
        description:
          "আপনার ব্যবসার উপযোগী মোবাইল অ্যাপ আমরা ডিজাইন ও ডেভেলপ করি — মসৃণ ইউজার এক্সপেরিয়েন্স, নিরাপদ আর্কিটেকচার এবং App Store ও Play Store-এ পূর্ণাঙ্গ লঞ্চ সাপোর্টসহ।",
        subServices: [
          "নেটিভ iOS ডেভেলপমেন্ট",
          "নেটিভ Android ডেভেলপমেন্ট",
          "ক্রস-প্ল্যাটফর্ম (React Native / Flutter)",
          "API ও ব্যাকএন্ড ইন্টিগ্রেশন",
          "পুশ নোটিফিকেশন ও অফলাইন সাপোর্ট",
          "App Store ও Play Store লঞ্চ",
        ],
      },
      custom: {
        title: "কাস্টম ওয়েবসাইট",
        bannerDescription:
          "আমরা এমন কাস্টম ওয়েবসাইট বানাই — যা আপনার ব্যবসায়িক চাহিদার সঙ্গে মানানসই এবং ফিচার ও ডিজাইনের ওপর আপনাকে দেয় পূর্ণ নিয়ন্ত্রণ।",
        description:
          "আপনার ব্যবসার জন্য কাস্টম ওয়েবসাইট তৈরি করি — রেসপনসিভ ডিজাইন ও সহজ ম্যানেজমেন্টসহ।",
        subServices: [
          "কাস্টম ডিজাইন ও ফাংশনালিটি",
          "SEO অপটিমাইজেশন",
          "দ্রুত ও নিরাপদ",
          "রেসপনসিভ ও মোবাইল-ফ্রেন্ডলি",
        ],
      },
      uiux: {
        title: "UI/UX",
        bannerDescription:
          "আমরা এমন ইউজার-ফ্রেন্ডলি ইন্টারফেস ও এক্সপেরিয়েন্স ডিজাইন করি — যা আপনার ওয়েবসাইট বা অ্যাপ ব্যবহারে সহজ করে।",
        description:
          "আমরা এমন UI/UX ডিজাইনে গুরুত্ব দিই যা ব্যবহারযোগ্যতা বাড়ায় এবং ইউজারদের জন্য আরও ভালো অভিজ্ঞতা তৈরি করে।",
        subServices: [
          "আধুনিক ভিজ্যুয়াল ডিজাইন",
          "ডিজাইন সিস্টেম তৈরি",
          "ইউজার রিসার্চ ও টেস্টিং",
          "ইউজার-ফ্রেন্ডলি ইন্টারফেস",
        ],
      },
    },
  },
  aboutUs: {
    banner: {
      title: "আমাদের সম্পর্কে",
      description: "আমাদের টিম ও লক্ষ্য সম্পর্কে আরও জানুন",
    },
    focus: {
      mission: {
        title: "আমাদের লক্ষ্য",
        description:
          "আমাদের লক্ষ্য সহজ: আমরা ক্লায়েন্টদের জন্য অনন্য এবং অত্যন্ত কার্যকর অনলাইন ফলাফল তৈরি করতে চাই।",
      },
      vision: {
        title: "আমাদের ভিশন",
        description:
          "আমরা এমন একটি দুনিয়ার স্বপ্ন দেখি, যেখানে প্রযুক্তি ব্যবসার পরিচালনায় বাধা না হয়ে বরং সহজে সাহায্য করবে — সৃজনশীলতা ও দক্ষতাকে এগিয়ে নেবে। আধুনিক প্রযুক্তির মাধ্যমে জটিল কৌশল ও অপারেশনগুলোকে আমরা সহজ করে তুলতে চাই।",
      },
      why: {
        title: "কেন আমরা এটা করি",
        description:
          "কারণ আমরা বিশ্বাস করি — প্রতিটি ব্যবসারই বৃদ্ধি, প্রতিযোগিতা ও সাফল্যের সুযোগ প্রাপ্য। ডিজিটাল জগৎ সম্ভাবনায় ভরপুর, আর ব্র্যান্ডগুলোকে নিজেদের পরিচয় গড়তে, পরিচিতি বাড়াতে এবং দীর্ঘমেয়াদী সাফল্য পেতে সাহায্য করাই আমাদের প্যাশন।",
      },
      how: {
        title: "কীভাবে আমরা এটা করি",
        description:
          "আমরা প্রযুক্তি, সৃজনশীলতা ও কৌশল একসাথে কাজে লাগিয়ে ব্যবসার উপযোগী ডিজিটাল সমাধান তৈরি করি। হাই-পারফরম্যান্স ওয়েবসাইট, SEO কৌশল থেকে শুরু করে ব্র্যান্ডিং ও মার্কেটিং ক্যাম্পেইন — সবকিছুকে আমরা বিশ্লেষণ, অপটিমাইজ ও বাস্তবায়ন করি, যাতে সর্বাধিক প্রভাব ও ROI পাওয়া যায়।",
      },
    },
    whyChooseUs: {
      title: "আমাদের কেন বেছে নেবেন?",
      description:
        "Build Web IT-তে আমরা বিশ্বাস করি — আপনার সফলতাই আমাদের সফলতা। ক্লায়েন্টরা কেন আমাদের ওপর আস্থা রাখেন:",
      points: {
        experiencedTeam: {
          title: "অভিজ্ঞ টিম",
          description:
            "আমাদের দক্ষ ডেভেলপার, ডিজাইনার ও স্ট্র্যাটেজিস্টরা প্রতিটি প্রজেক্টে বছরের পর বছরের হাতে-কলমে অভিজ্ঞতা নিয়ে আসেন।",
        },
        customSolutions: {
          title: "কাস্টম সমাধান",
          description:
            "আপনার ব্যবসার অনন্য চাহিদা মাথায় রেখে আমরা সফটওয়্যার ও ডিজিটাল প্রোডাক্ট তৈরি করি।",
        },
        endToEndService: {
          title: "এন্ড-টু-এন্ড সেবা",
          description:
            "আইডিয়া থেকে লঞ্চ পর্যন্ত — ডিজাইন, ডেভেলপমেন্ট, ডিপ্লয়মেন্ট ও সাপোর্ট সবকিছু আমরা সামলাই।",
        },
        onTimeDelivery: {
          title: "সময়মতো ডেলিভারি",
          description:
            "আমরা আপনার সময়কে মূল্য দিই এবং মান বজায় রেখে নির্ধারিত সময়ের মধ্যেই প্রজেক্ট সম্পন্ন করি।",
        },
        affordableTransparent: {
          title: "সাশ্রয়ী ও স্বচ্ছ",
          description:
            "কোনো লুকানো খরচ নেই — পরিষ্কার প্রাইসিং, যাতে কোথায় কী খরচ হচ্ছে আপনি ঠিকঠাক জানেন।",
        },
        longTermPartnership: {
          title: "দীর্ঘমেয়াদী পার্টনারশিপ",
          description:
            "আমরা কেবল প্রজেক্ট নয় — দীর্ঘস্থায়ী বৃদ্ধির জন্য সম্পর্কও গড়ে তুলি।",
        },
      },
    },
    departments: {
      title: "পেছন থেকে কাজ করা টিমের সঙ্গে পরিচিত হোন",
      items: {
        development: {
          title: "ডেভেলপমেন্ট",
          description:
            "আমাদের ডেভেলপমেন্ট টিম শক্তিশালী, স্কেলেবল ও সিকিউর অ্যাপ্লিকেশন তৈরি করে — যা আপনার ব্যবসার চাহিদা পূরণ করে। আমাদের ডেভেলপাররা ওয়েব ও মোবাইল অ্যাপ ডেভেলপমেন্টে বিশেষভাবে দক্ষ, যাতে আপনার ডিজিটাল প্রোডাক্ট হাই-পারফরম্যান্স ও ইউজার-ফ্রেন্ডলি হয়।",
        },
        design: {
          title: "গ্রাফিক ডিজাইন",
          description:
            "আমাদের ডিজাইন টিম দেখতে সুন্দর ও ইউজার-ফ্রেন্ডলি ইন্টারফেস তৈরি করে, যা ইউজার এক্সপেরিয়েন্স উন্নত করে। আমরা এমন ডিজাইন বানাই যা শুধু সুন্দরই নয় — বরং কার্যকর ও স্বাভাবিকভাবে ব্যবহারযোগ্য। ব্র্যান্ডিং আমাদের কাজের কেন্দ্রবিন্দু — আমাদের ডিজাইনাররা নিশ্চিত করেন যেন আপনার ব্র্যান্ড ডিজিটাল জগতে আলাদা করে চোখে পড়ে।",
        },
        management: {
          title: "প্রজেক্ট প্ল্যানিং ও ম্যানেজমেন্ট",
          description:
            "আমাদের প্রজেক্ট ম্যানেজাররা শুরু থেকে শেষ পর্যন্ত প্রজেক্ট মসৃণভাবে চালান। তাঁরা টিমগুলোর সঙ্গে সমন্বয় রাখেন, সময়সূচি ম্যানেজ করেন এবং নিশ্চিত করেন প্রজেক্ট যেন সময় ও বাজেটের মধ্যে ডেলিভার হয়। আমাদের প্রজেক্ট ম্যানেজমেন্ট স্বচ্ছ ও সহযোগিতামূলক — প্রতিটি ধাপেই আপনি অবগত থাকেন।",
        },
        support: {
          title: "কাস্টমার সাপোর্ট",
          description:
            "যেকোনো প্রশ্ন বা সমস্যায় সাহায্য করতে আমাদের কাস্টমার সাপোর্ট টিম প্রস্তুত। আমরা চমৎকার কাস্টমার সার্ভিস ও সাপোর্টে বিশ্বাসী, যাতে আমাদের সঙ্গে আপনার অভিজ্ঞতা মসৃণ ও ঝামেলামুক্ত থাকে। প্রজেক্ট-সংক্রান্ত প্রশ্ন থেকে শুরু করে টেকনিক্যাল সাপোর্ট — সব ক্ষেত্রেই আমাদের টিম আপনার পাশে।",
        },
      },
    },
  },
  faqPage: {
    label: "প্রশ্নোত্তর",
    title: "প্রচলিত প্রশ্নোত্তর",
    description: "আমাদের সেবা নিয়ে সবচেয়ে সাধারণ প্রশ্নগুলোর উত্তর দেখুন।",
    categories: {
      general: {
        title: "সাধারণ প্রশ্ন",
        questions: {
          services: {
            q: "আপনারা কী কী সেবা দেন?",
            a: "আমরা ওয়েব ডেভেলপমেন্ট, অ্যাপ ডিজাইন, UI/UX ডিজাইন এবং প্রোডাক্ট ডিজাইন সেবা দিই। প্রয়োজন হলে পুরোনো ওয়েবসাইট রিডিজাইন করা, ভুল ঠিক করা এবং হোস্টিং ও ডোমেইন সেটআপের কাজও করতে পারি।",
          },
          whyChoose: {
            q: "Build Web IT-কেই কেন বেছে নেবো?",
            a: "আমরা বাংলাদেশভিত্তিক একটি বাজেট-ফ্রেন্ডলি আইটি কোম্পানি। আমরা সবসময় সময়মতো কাজ ডেলিভারি দিই, প্রতিদিন ক্লায়েন্টকে অগ্রগতি জানাই এবং চূড়ান্ত প্রোডাক্ট যেন ইউজার-ফ্রেন্ডলি, রেসপনসিভ ও SEO-প্রস্তুত হয় — তা নিশ্চিত করি।",
          },
          smallLarge: {
            q: "আপনারা কি ছোট ও বড় দুই ধরনের প্রজেক্ট নেন?",
            a: "হ্যাঁ, যেকোনো সাইজের প্রজেক্ট আমরা নিতে পারি। বাগ ফিক্স থেকে শুরু করে পূর্ণাঙ্গ ওয়েবসাইট, অ্যাপ বা প্রোডাক্ট ডিজাইন — সবই করতে পারি।",
          },
          seoFriendly: {
            q: "আপনাদের কাজ কি SEO-ফ্রেন্ডলি?",
            a: "হ্যাঁ। আমরা শুরু থেকেই SEO-এর দিকে গুরুত্ব দিই — সঠিক তথ্য ও স্ট্রাকচার যোগ করি, যাতে আপনার ওয়েবসাইট গুগলের মতো সার্চ ইঞ্জিনে ভালোভাবে র‍্যাঙ্ক করে।",
          },
        },
      },
      development: {
        title: "ডেভেলপমেন্ট সংক্রান্ত প্রশ্ন",
        questions: {
          types: {
            q: "আপনারা কী ধরনের ওয়েবসাইট বানাতে পারেন?",
            a: "ব্যবসায়িক ওয়েবসাইট, ই-কমার্স সাইট, পোর্টফোলিও সাইট, ব্লগ এবং কাস্টম ওয়েব অ্যাপ — সবই আমরা বানাতে পারি। সব ওয়েবসাইটই রেসপনসিভ এবং মোবাইল, ডেস্কটপ ও ট্যাবলেট-সব ডিভাইসে কাজ করে।",
          },
          redesign: {
            q: "আমার পুরোনো ওয়েবসাইট কি রিডিজাইন করা সম্ভব?",
            a: "হ্যাঁ, আমরা আপনার পুরোনো ওয়েবসাইটকে আধুনিক, দ্রুতগতির, মোবাইল-ফ্রেন্ডলি ও SEO-প্রস্তুত করে রিডিজাইন করতে পারি।",
          },
          fixErrors: {
            q: "চলমান ওয়েবসাইটের ভুল কি আপনারা ঠিক করেন?",
            a: "হ্যাঁ, আপনার বর্তমান ওয়েবসাইটের টেকনিক্যাল সমস্যা, ভুল, বাগ ও পারফরম্যান্সজনিত ইস্যু — সবকিছুই আমরা সমাধান করতে পারি।",
          },
          hosting: {
            q: "আপনারা কি হোস্টিং ও ডোমেইন দেন?",
            a: "হ্যাঁ, বাজেট থাকলে আমরা আপনার ওয়েবসাইটের জন্য হোস্টিং ও ডোমেইন সেটআপ করে দিতে পারি। অন্যথায় কীভাবে নিজে নিতে পারবেন — তার গাইডলাইনও দিই।",
          },
        },
      },
      design: {
        title: "ডিজাইন সংক্রান্ত প্রশ্ন",
        questions: {
          productDesign: {
            q: "প্রোডাক্ট ডিজাইন বলতে কী বোঝায়?",
            a: "প্রোডাক্ট ডিজাইন মানে সহজ ও ইউজার-ফ্রেন্ডলি ডিজিটাল প্রোডাক্ট তৈরি করা। এটার মধ্যে অ্যাপ বা ওয়েবসাইটের জন্য লেআউট, ফ্লো এবং ইউজার এক্সপেরিয়েন্স ডিজাইন করা পড়ে — যা ইউজারদের বাস্তব সমস্যাগুলো সমাধান করে।",
          },
          androidIos: {
            q: "আপনারা কি Android ও iOS দুই প্ল্যাটফর্মেই অ্যাপ ডিজাইন করেন?",
            a: "হ্যাঁ, আমরা Android ও iOS — দুটোর জন্যই মোবাইল অ্যাপ ডিজাইন করি। আমাদের ডিজাইন সহজ, ব্যবহারবান্ধব এবং আপনার ব্যবসায়িক লক্ষ্যের সঙ্গে মানানসই।",
          },
          uiVsUx: {
            q: "UI আর UX ডিজাইনের পার্থক্য কী?",
            a: "UI ডিজাইন মানে অ্যাপ বা ওয়েবসাইটের চেহারা (কালার, ফন্ট, বাটন)। UX ডিজাইন মানে ইউজার সেটাকে কীভাবে ব্যবহার করছেন (সহজ নেভিগেশন, মসৃণ ফ্লো)। আমরা UI ও UX — দুটোই একসাথে দিই।",
          },
          customBrand: {
            q: "আমার ব্র্যান্ডের জন্য কাস্টম ডিজাইন কি তৈরি করতে পারবেন?",
            a: "হ্যাঁ, আপনার ব্র্যান্ড স্টাইল, লোগো ও ব্যবসায়িক চাহিদার সঙ্গে মিলিয়ে আমরা কাস্টম ডিজাইন তৈরি করতে পারি। ডিজাইন যেন প্রফেশনাল ও ইউজার-ফ্রেন্ডলি হয় — তা আমরা নিশ্চিত করি।",
          },
        },
      },
      process: {
        title: "প্রক্রিয়া ও ডেলিভারি সংক্রান্ত প্রশ্ন",
        questions: {
          startProject: {
            q: "নতুন প্রজেক্ট কীভাবে শুরু করেন?",
            a: "প্রথমে আমরা আপনার সঙ্গে কথা বলে আপনার চাহিদা বুঝি। এরপর সময় ও খরচ ব্যাখ্যা করি। আপনি একমত হলে কাজ শুরু করি এবং প্রতিদিন অগ্রগতি জানাতে থাকি।",
          },
          contentReady: {
            q: "শুরুর আগে কি সব কনটেন্ট হাতে থাকা লাগবে?",
            a: "না, সব কিছু হাতে রাখার দরকার নেই। আমরা প্রধান কনটেন্ট দিয়েই শুরু করতে পারি, বাকিটা কাজ চলাকালীন সংগ্রহ করা যাবে।",
          },
          revisions: {
            q: "রিভিশন কীভাবে হ্যান্ডেল করেন?",
            a: "আমরা সাধারণত প্রজেক্টের সঙ্গে ৩টি রিভিশন অন্তর্ভুক্ত রাখি। এর পরবর্তী রিভিশনের জন্য অতিরিক্ত চার্জ প্রযোজ্য। সব রিভিশন অনলাইন মিটিংয়ের মাধ্যমে আলোচনা করা হয়।",
          },
          cost: {
            q: "একটি প্রজেক্টের খরচ কত পড়বে?",
            a: "খরচ নির্ভর করে প্রজেক্টের সাইজ ও ধরনের ওপর। আপনার চাহিদা ও বাজেট অনুযায়ী আমরা কাস্টম প্রাইসিং দিই — সবসময় চেষ্টা করি বাজেট-ফ্রেন্ডলি থাকতে।",
          },
          timeline: {
            q: "একটি প্রজেক্ট শেষ হতে কত সময় লাগে?",
            a: "সময় নির্ভর করে প্রজেক্টের সাইজের ওপর। ছোট ওয়েবসাইট কয়েক দিনে শেষ হতে পারে, আবার বড় প্রজেক্টে কয়েক সপ্তাহ লাগতে পারে। শুরু করার আগেই আমরা আপনাকে একটি স্পষ্ট টাইমলাইন জানাই।",
          },
        },
      },
    },
  },
};
